
import Vue from "vue";
import store from "@/store";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { LOYALTY } from "@/store/loyalty";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { IEarnRate, LoyaltySchemeType } from "@/store/loyalty/types";
import {
  getFlyBuysMultiplier,
  getAirpointsMultiplier
} from "@/helpers/loyalty";

export default Vue.extend({
  data() {
    return {
      isLoading: false,
      headers: [
        { text: "Campaign name", value: "name" },
        { text: "Start date", value: "startDate" },
        { text: "End date", value: "endDate" },
        { text: "Fly Buys", value: "flyBuysMultiplier", sortable: false },
        { text: "Airpoints", value: "airpointsMultiplier", sortable: false }
      ],
      campaignDetailsRouteName: LOYALTY_ROUTE_NAMES.CAMPAIGNS_DETAILS
    };
  },
  methods: {
    onItemClick(item: any) {
      this.$router.push({
        name: this.campaignDetailsRouteName,
        params: { id: item.id }
      });
    },
    async onPagination(pagination: any) {
      (this as any).isLoading = true;

      await this.$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CAMPAIGN_LIST),
        {
          pagination: this.pagination
        }
      );

      (this as any).isLoading = false;
    }
  },
  computed: {
    pagination: {
      get() {
        return store.state.loyalty.dataTables.campaigns.pagination;
      },
      set(value: string) {
        this.$store.commit(
          LOYALTY.NS(LOYALTY.MUTATIONS.SET_CAMPAIGNS_PAGINATION),
          value
        );
      }
    },
    ...mapState({
      campaignList: (state: IRootState) =>
        state.loyalty.campaignList.map(campaign => ({
          ...campaign,
          airpointsMultiplier: getAirpointsMultiplier(campaign),
          flyBuysMultiplier: getFlyBuysMultiplier(campaign)
        })),
      paginationTotal: (state: IRootState) =>
        state.loyalty.campaignListPaginationTotal
    })
  }
});
